// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Export-ExportTable-NamesTab-module-grid {
	border-left: var(--StandardBorder);
	border-radius: 3px;
	border-top: var(--StandardBorder);
	margin: 25px;
}

.Export-ExportTable-NamesTab-module-radioGroup {
	display: -ms-flexbox;
	display: flex;
	width: 100%;
}

.Export-ExportTable-NamesTab-module-gridCell {
	border-bottom: var(--StandardBorder);
	border-right: var(--StandardBorder);
	-ms-flex: 1;
	    flex: 1;
	height: 28px;
	overflow: hidden;
	white-space: nowrap;
}

.Export-ExportTable-NamesTab-module-gridCell span {
		text-overflow: ellipsis;
	}

.Export-ExportTable-NamesTab-module-header {
	-ms-flex-align: center;
	    align-items: center;
	background-color: var(--Grey50);
	display: -ms-flexbox;
	display: flex;
	padding-left: 7px;
}

.Export-ExportTable-NamesTab-module-btnApplyAll {
	float: right;
    margin-left: auto;
	margin-right: 7px;
}

.Export-ExportTable-NamesTab-module-cell {
	padding: 12px 7px;
}

.Export-ExportTable-NamesTab-module-textField >div:not(.Mui-focused) {
		border: none;
	}

.Export-ExportTable-NamesTab-module-textField input {
		text-overflow: ellipsis;
	}

.Export-ExportTable-NamesTab-module-cellCustom {
	color: var(--DisabledText);
}
`, "",{"version":3,"sources":["webpack://./src/Export/ExportTable/NamesTab.module.css"],"names":[],"mappings":"AAAA;CACC,kCAAkC;CAClC,kBAAkB;CAClB,iCAAiC;CACjC,YAAY;AACb;;AAEA;CACC,oBAAa;CAAb,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,oCAAoC;CACpC,mCAAmC;CACnC,WAAO;KAAP,OAAO;CACP,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;AAIpB;;AAHC;EACC,uBAAuB;CACxB;;AAGD;CACC,sBAAmB;KAAnB,mBAAmB;CACnB,+BAA+B;CAC/B,oBAAa;CAAb,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,YAAY;IACT,iBAAiB;CACpB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAGC;EACC,YAAY;CACb;;AACA;EACC,uBAAuB;CACxB;;AAGD;CACC,0BAA0B;AAC3B","sourcesContent":[".grid {\n\tborder-left: var(--StandardBorder);\n\tborder-radius: 3px;\n\tborder-top: var(--StandardBorder);\n\tmargin: 25px;\n}\n\n.radioGroup {\n\tdisplay: flex;\n\twidth: 100%;\n}\n\n.gridCell {\n\tborder-bottom: var(--StandardBorder);\n\tborder-right: var(--StandardBorder);\n\tflex: 1;\n\theight: 28px;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\tspan {\n\t\ttext-overflow: ellipsis;\n\t}\n}\n\n.header {\n\talign-items: center;\n\tbackground-color: var(--Grey50);\n\tdisplay: flex;\n\tpadding-left: 7px;\n}\n\n.btnApplyAll {\n\tfloat: right;\n    margin-left: auto;\n\tmargin-right: 7px;\n}\n\n.cell {\n\tpadding: 12px 7px;\n}\n\n.textField {\n\t>div:not(:global(.Mui-focused)) {\n\t\tborder: none;\n\t}\n\tinput {\n\t\ttext-overflow: ellipsis;\n\t}\n}\n\n.cellCustom {\n\tcolor: var(--DisabledText);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `Export-ExportTable-NamesTab-module-grid`,
	"radioGroup": `Export-ExportTable-NamesTab-module-radioGroup`,
	"gridCell": `Export-ExportTable-NamesTab-module-gridCell`,
	"header": `Export-ExportTable-NamesTab-module-header`,
	"btnApplyAll": `Export-ExportTable-NamesTab-module-btnApplyAll`,
	"cell": `Export-ExportTable-NamesTab-module-cell`,
	"textField": `Export-ExportTable-NamesTab-module-textField`,
	"cellCustom": `Export-ExportTable-NamesTab-module-cellCustom`
};
module.exports = ___CSS_LOADER_EXPORT___;
